import React, {cloneElement} from 'react'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

import chevronDownIcon from '../../assets/icons/chevron-down.svg'

import FilterSelectFlyout from '../filter-select-flyout'
import Icon from '../icon'
import PopoverHandler from '../popover-handler'

type Props = Overwrite<
  CommonProps<'button'>,
  {
    label: string
    isOpen: boolean
    menu: React.ReactElement<React.ComponentProps<typeof FilterSelectFlyout>>
    onClick: React.MouseEventHandler
    onShouldClose: () => void
    active?: boolean
    disabled?: boolean
    size?: '100' | '90'
  }
>

const FilterSelect = ({
  className,
  label,
  isOpen,
  menu,
  onClick,
  onShouldClose,
  active = false,
  disabled = false,
  size = '100',
  ...props
}: Props) => {
  const mainContent = (
    <button
      {...props}
      className={cn(
        'FilterSelect',
        {
          open: isOpen,
          active,
          disabled,
          [`size-${size}`]: !!size,
        },
        className
      )}
      onClick={onClick}
      type="button"
      disabled={disabled}
    >
      <span className="FilterSelect__label">{label}</span>
      <span className="FilterSelect__icon">
        <Icon source={chevronDownIcon} />
      </span>
    </button>
  )

  if (menu) {
    return (
      <PopoverHandler
        isOpen={isOpen}
        onOpenChange={value => !value && onShouldClose()}
        distanceToAnchor={4}
        popover={
          <div className="FilterSelect__menu">
            {cloneElement(menu, {
              onClose: () => {
                onShouldClose()
              },
            })}
          </div>
        }
      >
        {mainContent}
      </PopoverHandler>
    )
  }

  return mainContent
}

export default FilterSelect
